import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue';
import { useStore, useRouter, useRouteRef } from '@/composables';


const __default__ = {
  name: 'AccessDeniedDialog',
};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

const store = useStore();
const router = useRouter();
const route = useRouteRef();

const getIsSessionExpiredDialogOpen = computed(() => store.getters['common/getIsSessionExpiredDialogOpen']);

function closeDialog() {
  store.commit('auth/clearAuthTokenAndProfileInfo');
  store.commit('common/changeSessionExpiredDialogOpenState', false);
  router.push({ name: 'Booking', lang: route.value.params.lang } as any);
}

return { __sfc: true,store, router, route, getIsSessionExpiredDialogOpen, closeDialog }
}

})